import axios from "@/api/axiosInstance";
import { FetchSpecialtiesRequest, FetchSpecialtiesResponse } from "./types";

export const fetchSpecialties = async (
  params: FetchSpecialtiesRequest = {},
): Promise<FetchSpecialtiesResponse> => {
  const response = await axios.get<FetchSpecialtiesResponse>(
    "/api/private/employee-directory/specialties",
    { params },
  );
  return response.data;
};
